import { registerCondition } from 'core/forms';

const isFrequencySelected = ({ model }) => ({
  condition: null,
  hasCondition: (!model.rrule?.frequency),
});

registerCondition('isFrequencySelected', isFrequencySelected);

export default isFrequencySelected;
